import gsap from 'gsap';
import ScrollToPlugin from 'gsap/ScrollToPlugin';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);

export default class MenuScrollAnimation {
    constructor(container) {
        if (!container) return;

        this.containerString = container;
        this.container = document.querySelector(container);
        this.menu = this.container.querySelector('.nav--offcanvas');
    }

    cloneMenuItems() {
        // Clone the menu items and append them to create a looping effect
        const clone = this.menu.cloneNode(true);
        this.container.querySelector('.menu-container__content').appendChild(clone);
    }

    init() {
        // Clone the menu items to create an infinite loop effect
        this.cloneMenuItems();

        // Recalculate maxHeight after cloning
        this.maxHeight = this.container.scrollHeight;

        this.setupScrollTrigger();
    }

    setupScrollTrigger() {
        // gsap.to(this.menu, {
        //     ease: 'none',
        //     scrollTrigger: {
        //         trigger: this.menu,
        //         scroller: this.container, // Use the container as the scrollable element
        //         start: 'top top',
        //         end: `bottom top`, // Loop based on the scrollable height
        //         scrub: 1,
        //         pin: false,
        //         markers: true, // Remove in production
        //         invalidateOnRefresh: false,
        //         onUpdate: (self) => {
        //             // Infinite scroll logic
        //             if (self.progress === 1) {
        //                 self.scroll(self.start); // Jump back to the top when at the bottom
        //             } else if (self.progress === 0) {
        //                 self.scroll(self.end); // Jump back to the bottom when at the top
        //             }
        //         },
        //     },
        // });
    }
}
